module.exports = __webpack_public_path__ + "static/media/electrical.4baf79e7.jpg";